/**
 * This file contains helpers for temporarily propagating context, similar to a Python decorator
 * that sets context and cleans it up when returning. These helpers should be considered legacy and
 * avoided for new code since:
 * - it is inherently not type safe
 * - it uses unexpected `this` binding
 * - there are nicer alternatives like Redux, useGlobalClientState, etc.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const stack: Array<Record<string | number, any>> = [];

/**
 * @deprecated
 * WARNING! If there is any ansychronous code that is not `await`ed inside of `func`, then `Context.get` may
 * not return expected values, during or after this call to `Context.using`. (Under other circumstances it is
 * acceptable to call async functions without `await`ing.)
 *
 * See the `describe('async danger')` section of Context-test.ts for some examples of problematic code.
 * Real world problems can be more convoluted.
 */
function using<This>(newContext: Object, thisArg: This, func: (arg?: This) => void): void {
  stack.push(newContext);
  try {
    func.call(thisArg);
  } finally {
    stack.pop();
  }
}

/**
 * @deprecated
 * WARNING! If there is any ansychronous code that is not `await`ed inside of `func`, then `Context.get` may
 * not return expected values, during or after this call to `Context.usingAsync`. (Under other circumstances
 * it is acceptable to call async functions without `await`ing.)
 *
 * See the `describe('async danger')` section of Context-test.ts for some examples of problematic code.
 * Real world problems can be more convoluted.
 */
async function usingAsync<This, Return>(
  newContext: Object,
  thisArg: This,
  func: (arg?: This) => Return
): Promise<Return> {
  stack.push(newContext);
  try {
    return await func.call(thisArg);
  } finally {
    stack.pop();
  }
}

/**
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function get(key: string | number, defaultValue: any = null): any {
  // Loop through array in reverse to search for key in order of descending specificity.
  for (let i = stack.length - 1; i >= 0; i--) {
    if (stack[i].hasOwnProperty(key)) {
      return stack[i][key];
    }
  }
  return defaultValue;
}

export {using, usingAsync, get};
